import { Controller } from 'lib_ts/enums/routing/controllers';
import { VisionCameraCalibrationsRoutes } from 'lib_ts/enums/routing/routes/vision-camera-calibrations';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import {
  IVCCDistanceDeltaPayload,
  IVCCUploadPayload,
  IVisionCameraCalibration,
} from 'lib_ts/interfaces/vision/i-vision-camera-calibration';
import { BaseRESTService } from 'services/_base-rest.service';

// for dealing with vision-camera-calibrations
export class VisionCameraCalibrationsService extends BaseRESTService {
  private static instance: VisionCameraCalibrationsService;
  static getInstance(): VisionCameraCalibrationsService {
    if (!VisionCameraCalibrationsService.instance) {
      VisionCameraCalibrationsService.instance =
        new VisionCameraCalibrationsService();
    }

    return VisionCameraCalibrationsService.instance;
  }

  private constructor() {
    super({
      controller: Controller.VisionCameraCalibrations,
    });
  }

  async getOne(id: string): Promise<IVisionCameraCalibration | undefined> {
    return await this.get({
      uri: `${VisionCameraCalibrationsRoutes.GetOne}/${id}`,
    })
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return undefined;
        }

        return res.data as IVisionCameraCalibration | undefined;
      })
      .catch((err) => {
        console.error(err);
        return undefined;
      });
  }

  async getLastCompleted(
    machineID: string
  ): Promise<IVisionCameraCalibration | undefined> {
    return await this.get({
      uri: `${VisionCameraCalibrationsRoutes.GetLastCompleted}/${machineID}`,
    })
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return undefined;
        }

        return res.data as IVisionCameraCalibration | undefined;
      })
      .catch((err) => {
        console.error(err);
        return undefined;
      });
  }

  async createOne(
    payload: Partial<IVisionCameraCalibration>
  ): Promise<IVisionCameraCalibration | undefined> {
    return await this.post(
      {
        uri: VisionCameraCalibrationsRoutes.CreateOne,
      },
      payload
    )
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return undefined;
        }

        return res.data as IVisionCameraCalibration | undefined;
      })
      .catch((err) => {
        console.error(err);
        return undefined;
      });
  }

  async updateOne(
    id: string,
    payload: Partial<IVisionCameraCalibration>
  ): Promise<IVisionCameraCalibration | undefined> {
    return await this.put(
      {
        uri: `${VisionCameraCalibrationsRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return undefined;
        }

        return res.data as IVisionCameraCalibration | undefined;
      })
      .catch((err) => {
        console.error(err);
        return undefined;
      });
  }

  async uploadToSlack(payload: IVCCUploadPayload): Promise<boolean> {
    return await this.post(
      {
        uri: `${VisionCameraCalibrationsRoutes.UploadToSlack}`,
      },
      payload
    )
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return false;
        }

        return true;
      })
      .catch((err) => {
        console.error(err);
        return false;
      });
  }

  async postDistanceDelta(payload: IVCCDistanceDeltaPayload): Promise<boolean> {
    return await this.post(
      {
        uri: `${VisionCameraCalibrationsRoutes.PlateDistanceDelta}`,
      },
      payload
    )
      .then((res: IServerResponse) => {
        if (res.error) {
          console.error(res.error);
          return false;
        }

        return true;
      })
      .catch((err) => {
        console.error(err);
        return false;
      });
  }
}
